import angular from 'angular';

export default angular.module('shared').constant('instanceConstants', {
    deploymentType: {
        public: {
            name: 'Public',
            displayName: 'Public Cloud'
        },
        private: {
            name: 'Private',
            displayName: 'Private Cloud'
        },
        onPremise: {
            name: 'OnPremise',
            displayName: 'On-Prem'
        }
    }
});



// WEBPACK FOOTER //
// ./modules/shared/constants/instance.constant.js